<template>
	<div>
		<case-form :schema="schemaCovid" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">Have you ever had:</div>
		<case-form :schema="schema" />

		<case-form :schema="smokingHabits" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">If “Yes,” please provide details:</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Additional Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="smokingHabitsList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="drugHabits" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">If “Yes,” please provide details:</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Additional Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="drugHabitsList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<case-form :schema="alcoholConsumption" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			Please give details for “Yes” answers to any of the questions above.
			Please reference the question number and provide details, including the
			date of occurrence, the impairment, and the name and address of doctors,
			medical clinics, health care advisors and hospitals.
		</div>
		<j-accordion
			v-for="i in 22"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Additional Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form
					:schema="schemaPersonalHealthExtraDetails(i)"
					:isBoxed="false"
				/>
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		schema() {
			return [
				{
					label: `B1. High blood pressure, high cholesterol, angina, chest pain, heart attack, coronary artery disease, heart murmur, irregular
heartbeat, transient ischemic attack (TIA), stroke or cerebrovascular accident (CVA), blood clot(s), peripheral vascular
disease (poor circulation), aneurysm, or any other disease or disorder of the heart or blood vessels?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ1`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ1`
						},
						createOptions: {
							type: `personalHealthQ1`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B2. Anemia, hemophilia, or any other blood or bleeding disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ2`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ2`
						},
						createOptions: {
							type: `personalHealthQ2`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B3. Asthma, chronic obstructive pulmonary disease (COPD), emphysema, chronic or recurrent bronchitis, sleep apnea,
sarcoidosis, cystic fibrosis, tuberculosis, persistent cough, hoarseness, shortness of breath or difficulty breathing,
or any other respiratory disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ3`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ3`
						},
						createOptions: {
							type: `personalHealthQ3`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B4. Chronic anxiety, depression, burnout, chronic fatigue syndrome, attention deficit disorder (ADD) or attention deficit
hyperactivity disorder (ADHD), eating disorder, schizophrenia, attempted suicide, any other psychological, emotional
or nervous disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ4`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ4`
						},
						createOptions: {
							type: `personalHealthQ4`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B5. Hepatitis (including hepatitis carrier state), cirrhosis, jaundice, Crohn’s disease, ulcerative colitis, irritable bowel
syndrome, diverticulitis, persistent diarrhea, rectal or intestinal bleeding, ulcer (peptic or gastric), pancreatitis,
or any other disease or disorder of the bowel, stomach, pancreas or liver?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ5`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ5`
						},
						createOptions: {
							type: `personalHealthQ5`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B6. Diabetes, gestational diabetes, abnormal blood sugar, goiter, hyperthyroidism, hypothyroidism, lymph or gland disease
or disorder, or any other thyroid, pituitary or endocrine disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ6`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ6`
						},
						createOptions: {
							type: `personalHealthQ6`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B7. Lupus, scleroderma, arthritis, fibromyalgia, muscular dystrophy, paralysis, or any other disease or disorder of the skin,
connective tissue, muscles, joints, limbs, back or bones?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ7`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ7`
						},
						createOptions: {
							type: `personalHealthQ7`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B8. Cancer, leukemia, lymphoma, melanoma, dysplastic nevus (atypical mole), basal cell carcinoma, tumor, cyst(s), polyp(s),
any other growths or malignancy?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ8`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ8`
						},
						createOptions: {
							type: `personalHealthQ8`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B9. Abnormal prostate specific antigen (PSA), prostatitis or any other prostate disease or disorder, breast lump(s) or cyst(s),
abnormal mammogram or pap smear, hysterectomy, disease or disorder of the ovary or uterus, sexually transmitted disease,
disease or disorder of the genital organs, kidney stone(s), nephritis, urinary tract infection, sugar, blood or protein in the
urine, or any other kidney or bladder disease or disorder?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ9`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ9`
						},
						createOptions: {
							type: `personalHealthQ9`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B10. Autism, cerebral palsy, Down syndrome, developmental delay, epilepsy or seizure(s), multiple sclerosis (MS), loss of balance,
consciousness, sensation or speech, coma, concussion, severe headaches(s), dizziness, fainting, Parkinson’s disease, tremor,
Alzheimer’s disease, dementia or cognitive impairment, amyotrophic lateral sclerosis (ALS), or any other disease or disorder
of the brain or nervous system?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ10`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ10`
						},
						createOptions: {
							type: `personalHealthQ10`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `B11. Any disorder of the eyes (excluding any vision impairment corrected with glasses or contact lenses), ears, nose, throat or mouth?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQ11`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQ11`
						},
						createOptions: {
							type: `personalHealthQ11`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `C. Have you ever been tested for or has anyone ever recommended that you be tested for exposure to the HIV (AIDS) virus?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTestedForHIV`,
					props: {
						suggest: {
							typeIncludes: `hasTestedForHIV`
						},
						createOptions: {
							type: `hasTestedForHIV`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `D. Have you ever been treated for or had any indication of AIDS, HIV infection or any other disease or disorder of the immune system?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasHIV`,
					props: {
						suggest: {
							typeIncludes: `hasHIV`
						},
						createOptions: {
							type: `hasHIV`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `E. Have you ever had a blood transfusion?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBloodTransfusion`,
					props: {
						suggest: {
							typeIncludes: `hasBloodTransfusion`
						},
						createOptions: {
							type: `hasBloodTransfusion`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `F. Other than for conditions already disclosed, in the last 5 years, have you had any medical or diagnostic tests, such as X-rays,
ECG, scans, MRI, ultrasounds, biopsies or blood tests? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMedicalOrDiagnosticTest`,
					props: {
						suggest: {
							typeIncludes: `hasMedicalOrDiagnosticTest`
						},
						createOptions: {
							type: `hasMedicalOrDiagnosticTest`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `G. Have you been hospitalized or had any surgery in the last 10 years?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasSurgery`,
					props: {
						suggest: {
							typeIncludes: `hasSurgery`
						},
						createOptions: {
							type: `hasSurgery`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `H. Do you have any symptoms for which you have not yet consulted a physician or received treatment? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasUnconsultedSymptoms`,
					props: {
						suggest: {
							typeIncludes: `hasUnconsultedSymptoms`
						},
						createOptions: {
							type: `hasUnconsultedSymptoms`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `I. Other than for conditions already disclosed, has a doctor recommended any tests or referrals that have not yet been completed,
or are you currently awaiting test results?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isWaitingForTestResult`,
					props: {
						suggest: {
							typeIncludes: `isWaitingForTestResult`
						},
						createOptions: {
							type: `isWaitingForTestResult`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `J. Do you have a deformity or an amputation?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeformityOrAmputation`,
					props: {
						suggest: {
							typeIncludes: `hasDeformityOrAmputation`
						},
						createOptions: {
							type: `hasDeformityOrAmputation`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `K. Are you taking any prescribed or non-prescribed medications?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isUnderMedication`,
					props: {
						suggest: {
							typeIncludes: `isUnderMedication`
						},
						createOptions: {
							type: `isUnderMedication`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCovid() {
			return [
				{
					label: `Have you tested positive for COVID-19?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasTestedPostiveForCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasTestedPostiveForCovid19`
						},
						createOptions: {
							type: `hasTestedPostiveForCovid19`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, been advised to self-isolate or stay home due to COVID-19 (excluding mandatory government orders to remain at home)?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenAdvisedToIsolateDueToCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasBeenAdvisedToIsolateDueToCovid19`
						},
						createOptions: {
							type: `hasBeenAdvisedToIsolateDueToCovid19`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, Had a persistent cough, fever or raised temperature, malaise, rhinorrhea (mucus discharge from the nose), sore throat,
gastro-intestinal symptoms such as nausea, vomiting and/or diarrhea?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasCovid19SymptomsInLast30Days`,
					props: {
						suggest: {
							typeIncludes: `hasCovid19SymptomsInLast30Days`
						},
						createOptions: {
							type: `hasCovid19SymptomsInLast30Days`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 30 days have you, Had any contact with an individual suspected or confirmed to have COVID-19?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasContactWithCovid19PatientInLast30Days`,
					props: {
						suggest: {
							typeIncludes: `hasContactWithCovid19PatientInLast30Days`
						},
						createOptions: {
							type: `hasContactWithCovid19PatientInLast30Days`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If “Yes” to any of the above, have you made a full recovery and returned to normal activities?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRecoveredFromCovid19`,
					props: {
						suggest: {
							typeIncludes: `hasRecoveredFromCovid19`
						},
						createOptions: {
							type: `hasRecoveredFromCovid19`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		smokingHabits() {
			return [
				{
					label: `Have you ever used tobacco or nicotine products in any form (including but not limited to cigarettes,
cigars, cigarillos, pipe, chewing tobacco, marijuana, nicotine patches, gum or shisha)? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProduct`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProduct`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProduct`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		drugHabits() {
			return [
				{
					label: `In the last 10 years have you used cocaine, LSD or other psychoactive drugs, heroin, or other narcotics?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasUsedPsychoactiveDrugsInPast10Years`,
					props: {
						suggest: {
							typeIncludes: `hasUsedPsychoactiveDrugsInPast10Years`
						},
						createOptions: {
							type: `hasUsedPsychoactiveDrugsInPast10Years`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		alcoholConsumption() {
			return [
				{
					label: `Do you currently drink alcohol?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isCurrentlyDrinkingAlcohol`,
					props: {
						suggest: {
							typeIncludes: `isCurrentlyDrinkingAlcohol`
						},
						createOptions: {
							type: `isCurrentlyDrinkingAlcohol`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>If “Yes,” which of the following best describes the average frequency of your alcohol consumption? </div>`
					},
					bindTo: ""
				},
				{
					label: `Daily`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholDaily`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholDaily`
						},
						createOptions: {
							type: `isDrinkingAlcoholDaily`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Weekly`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholWeekly`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholWeekly`
						},
						createOptions: {
							type: `isDrinkingAlcoholWeekly`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Monthly`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholMonthly`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholMonthly`
						},
						createOptions: {
							type: `isDrinkingAlcoholMonthly`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Less than once per month`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isDrinkingAlcoholOncePerMonth`,
					props: {
						suggest: {
							typeIncludes: `isDrinkingAlcoholOncePerMonth`
						},
						createOptions: {
							type: `isDrinkingAlcoholOncePerMonth`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `On those days when you drink alcohol, how many drinks do you typically have?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alcoholConsumptionPerDay`,
					props: {
						suggest: {
							typeIncludes: `alcoholConsumptionPerDay`
						},
						createOptions: {
							type: `alcoholConsumptionPerDay`,
							dataType: "string"
						}
					}
				},
				{
					label: `Have you ever received treatment or been advised to reduce use or frequency of use, seek treatment, counseling or medical
advice due to your use of drugs or alcohol?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alcoholConsumptionCounseling`,
					props: {
						suggest: {
							typeIncludes: `alcoholConsumptionCounseling`
						},
						createOptions: {
							type: `alcoholConsumptionCounseling`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPersonalHealthExtraDetails(i) {
			return [
				{
					label: `Question Number`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthQuestionNumber${i}`,
					props: {
						suggest: {
							typeIncludes: `personalHealthQuestionNumber${i}`
						},
						createOptions: {
							type: `personalHealthQuestionNumber${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDate${i}`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDate${i}`
						},
						createOptions: {
							type: `personalHealthDate${i}`,
							dataType: "date"
						}
					}
				},
				{
					label: `Details`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDetails${i}`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDetails${i}`
						},
						createOptions: {
							type: `personalHealthDetails${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Name and address of doctors, medical clinics,
health care advisors and hospitals`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalHealthDoctorNameAndDetails${i}`,
					props: {
						suggest: {
							typeIncludes: `personalHealthDoctorNameAndDetails${i}`
						},
						createOptions: {
							type: `personalHealthDoctorNameAndDetails${i}`,
							dataType: "string"
						}
					}
				}
			]
		},

		smokingHabitsList(i) {
			return [
				{
					label: `Product ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoProduct${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoProduct${i}`
						},
						createOptions: {
							type: `tobaccoProduct${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount and frequency of use ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoFrequency${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoFrequency${i}`
						},
						createOptions: {
							type: `tobaccoFrequency${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date last used ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoDateLastUsed${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoDateLastUsed${i}`
						},
						createOptions: {
							type: `tobaccoDateLastUsed${i}`,
							dataType: "date"
						}
					}
				}
			]
		},

		drugHabitsList(i) {
			return [
				{
					label: `Product ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugProduct${i}`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugProduct${i}`
						},
						createOptions: {
							type: `psychoactiveDrugProduct${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount and Frequency of use ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugAmount${i}`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugAmount${i}`
						},
						createOptions: {
							type: `psychoactiveDrugAmount${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date last used ${i}`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0psychoactiveDrugLastUsed${i}`,
					props: {
						suggest: {
							typeIncludes: `psychoactiveDrugLastUsed${i}`
						},
						createOptions: {
							type: `psychoactiveDrugLastUsed${i}`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
